@let challenges = challengeData(); @let opportunities = opportunityData();
<article>
    <h1 i18n>🌍 Step 1: Learning Outcomes</h1>

    <p i18n>
        In this step, you will map the Intended Learning Outcomes (ILOs) for
        your course and link each one to the most relevant Dublin Descriptor.
    </p>

    <p i18n>
        The Dublin Descriptors are internationally recognized criteria to
        classify learning outcomes. They are organized into five categories:
    </p>

    <ul>
        <li i18n>Knowledge and understanding</li>
        <li i18n>Applying knowledge and understanding</li>
        <li i18n>Making judgments</li>
        <li i18n>Communication</li>
        <li i18n>Lifelong learning skills</li>
    </ul>

    <p i18n>
        Enter the intended learning outcomes of your course here (one per
        field). You can do this in your own words. For each ILO you enter,
        please select the Dublin Descriptor that best aligns.
    </p>

    @if (form.controls.learningOutcomes.length > 0) {
    <form>
        <table class="table table-primary gr-table">
            <thead>
                <tr>
                    <th i18n>Intended Outcome</th>
                    <th i18n>Dublin Descriptor</th>
                    <th i18n>Actions</th>
                </tr>
            </thead>
            <tbody>
                @for ( subForm of form.controls.learningOutcomes.controls; track
                $index ) { @let dublinValue =
                subForm.controls.dublinIndicator.value;
                <tr [formGroup]="subForm">
                    <td class="my-4">
                        <input
                            class="form-control"
                            [formControl]="subForm.controls.intendedOutcome"
                        />
                    </td>
                    <td>
                        <select
                            class="form-select"
                            [formControl]="subForm.controls.dublinIndicator"
                        >
                            @for ( option of dublinIndicatorOptions; track
                            $index ) {
                            <option [value]="option.value">
                                {{ option.label }}
                            </option>
                            }
                        </select>
                    </td>
                    <td>
                        <button
                            type="button"
                            class="btn btn-outline-secondary small btn-small"
                            (click)="
                                removeLearningOutcome(subForm.controls.id.value)
                            "
                            [disabled]="
                                form.controls.learningOutcomes.length <= 1
                            "
                            i18n
                        >
                            Remove
                        </button>
                    </td>
                </tr>
                @if (challenges && dublinValue) {
                <tr [@expandIn] class="animated-row">
                    <td>
                        @if (challenges && dublinValue) {
                        <strong i18n>AI Challenges:</strong>
                        <ul>
                            @for ( challenge of challenges[dublinValue]; track
                            $index ) {
                            <li>{{ challenge }}</li>
                            }
                        </ul>
                        }
                    </td>
                    <td>
                        @if (opportunities && dublinValue) {
                        <strong i18n>AI Opportunities:</strong>
                        <ul>
                            @for ( opportunity of opportunities[dublinValue];
                            track $index ) {
                            <li>{{ opportunity }}</li>
                            }
                        </ul>
                        }
                    </td>
                    <td></td>
                </tr>
                } }
            </tbody>
        </table>
    </form>
    }

    <button
        class="btn btn-outline-secondary"
        (click)="addLearningOutcome()"
        i18n
    >
        Add new intended learning outcome
    </button>
</article>

<gr-nav-buttons [navButtons]="navButtons"></gr-nav-buttons>
